import { render, staticRenderFns } from "./ptTableRowLottery.vue?vue&type=template&id=cfb0a71c&lang=pug&"
import script from "./ptTableRowLottery.vue?vue&type=script&lang=js&"
export * from "./ptTableRowLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports